import { ProjectType } from "./study.dtos";
export function computeProjectTypeLabel(projectType, isPdde) {
    if (projectType === undefined || projectType === null)
        return null;
    const typeLabel = projectType === ProjectType.GENERAL_DATA_USE ? "General Data Use" : projectType === ProjectType.AI_DATA_USE ? "AI Data Use" : null;
    if (!typeLabel)
        return null;
    return `${typeLabel} ${isPdde ? "PDDE" : "Non-PDDE"}`;
}
